import { toast } from 'vue3-toastify'
export const errorToaster = (key: string, message: string) => {
	// toast.error(`Error in ${key}: ${message}`)
	toast.error(`${message}`)
}
